import React from 'react';
import '../StyleSheets/LineChart.css';
import { Line } from 'react-chartjs-2';

import 'chartjs-plugin-zoom';

export default class LineChart extends React.Component {
	constructor(props) {
        super(props);

		this.tooltipFooterCB = this.tooltipFooterCB.bind(this);
		this.onChartClickHandler = this.onChartClickHandler.bind(this);
		
        this.basicDataSet = {
            label: 'My First dataset',
			fill: false,
			snapGaps: true,
			lineTension: 0.1,
            backgroundColor: 'rgba(55,153,221,0.4)',
            borderColor: 'rgba(55,153,221,1)',
            borderCapStyle: 'butt',
            borderDash: [],
            borderDashOffset: 0.0,
            borderJoinStyle: 'miter',
            pointBorderColor: 'rgba(0,0,0)',
            pointBackgroundColor: '#ffffff',
            pointBorderWidth: 2,
            pointHoverRadius: 0,
            pointHoverBackgroundColor: '#ffffff',
            pointHoverBorderWidth: 2,
            // pointRadius: 1,
            pointHitRadius: 10,
            data: [],
          }
    
        this.basicOptions = {
            layout: {
                padding: {
                    left: 40,
                    right: 260,
                    top: 100,
                    bottom: 40
                }
            },
            legend: {
                display: false
            },
			maintainAspectRatio: false,
			scales: {
				xAxes: [{
					type: 'time',
					time: {
						unit: 'day'
					},
					ticks: {
						autoSkip: true,
						autoSkipPadding: 10,
						padding: 10,
					}
				}],
				yAxes: [{
					id: 'main-y-axis',
					type: 'linear',
					ticks: {						
						autoSkip: true,
						autoSkipPadding: 10,
						padding: 10,
					}
					
				}]
			},

			plugins: {
				zoom: {
					pan: {
						enabled: true,
			
						mode: 'x',
			
						rangeMin: {
							x: null,
							y: null
						},
						rangeMax: {
							x: null,
							y: null
						},
			
						speed: 20,
			
						threshold: 1,
			
						// Function called while the user is panning
						// onPan: function({chart}) { console.log(`I'm panning!!!`); },
						// Function called once panning is completed
						// onPanComplete: function({chart}) { console.log(`I was panned!!!`); }
					},
			
					zoom: {
						
						enabled: true,
						drag: false,
						mode: 'x',
						rangeMin: {
							x: null,
							y: null
						},
						rangeMax: {
							x: null,
							y: null
						},
			
						speed: 0.1,
			
						sensitivity: 3,
			
						// Function called while the user is zooming
						// onZoom: function({chart}) { console.log(`I'm zooming!!!`); },
						// Function called once zooming is completed
						// onZoomComplete: function({chart}) { console.log(`I was zoomed!!!`); }
					}
				}
			},

            tooltips: {
				enabled: props.useToolTips,
				bodyAlign: 'right',
				rtl: true,
				xPadding: 16,
				yPadding: 16,
				titleMarginBottom: 12,
				bodyMarginBottom: 12,
				bodyFontSize: 14,
				footerFontSize: 14,
				displayColors: false,
                callbacks: {
					title: ( tooltipItem, data ) => {
						const country = data.datasets[ tooltipItem[0].datasetIndex ].label;
						// const shortDate = tooltipItem[0].label.slice( 0, tooltipItem[0].label.length - 13 );
						return country; // to present the date change this to: "shortDate"
					},
					footer: this.tooltipFooterCB,
                     label: function( tooltipItem, data ) {
						const dset = data.datasets[tooltipItem.datasetIndex];
						const inx = tooltipItem.index;
						const severity = dset.covidPointsData.pointSeverities[inx];
						const severityText = data.hebrewLegend[data.eventsType][severity];

						let eventText = dset.covidPointsData.pointsLabels[inx];
						eventText = eventText.length > 40 ? eventText.substr(0, 40) + "..." : eventText;
						

                        return severityText ? severityText : eventText !== "null" ? eventText : "-";
					 },
					 labelTextColor: function(tooltipItem, chart) {
						 
						const dset = chart.data.datasets[tooltipItem.datasetIndex];
						const inx = tooltipItem.index;
						const severity = dset.covidPointsData.pointSeverities[inx];
						const severityBetweenZeroAndOne = (severity - 1) / 2;
						if (severityBetweenZeroAndOne >= 0 && severityBetweenZeroAndOne <= 1) {
							const color = chart.data.severityGradient.rgbAt(severityBetweenZeroAndOne);
							return color;
						}
						
					}
					//  afterLabel: function( tooltipItem, data ) {
					//    return "-";
					// },
				},				
			},

			onClick: this.onChartClickHandler,
		}
		
	}

	tooltipFooterCB( tooltipItem, data ) {

		const dset = data.datasets[tooltipItem[0].datasetIndex];
		// const bodyMaxLength = 50;
		let body = "";

		const inx = tooltipItem[0].index;
		let eventText = dset.covidPointsData.pointsLabels[inx];
		const severity = dset.covidPointsData.pointSeverities[inx];
		const sColor = dset.covidPointsData.pointColors[inx];

		this.currentPolityData = {t: eventText, c: sColor, s: severity};
		
		if( eventText !== "null" ) {
		
			// Edit 29/3/2020
			// There might be more than one category at once 
			// and the severity category shown in tool tip is not necessarily the first one...
			// For this reason it's better not to show the eventText content, but only to ask the user to click to extend.

			// eventText = eventText.length > bodyMaxLength ? eventText.substr(0, bodyMaxLength-1) + "... (לחצו להרחבה)" : eventText;

			eventText = "לחצו להרחבה"
			body = eventText;

			// this.setState( {eventPolicyText:eventText} )
		
		} else {

			// this.setState( {eventPolicyText:""} )

		}

		return body;
	}

	onChartClickHandler( event, item ) {

		// console.log( item );
		if( item.length === 0 || this.currentPolityData.t === "null" ) return;
		this.redraw = false; 
		this.props.onExpandPolicy(this.currentPolityData);
	}
	
	state = {
		eventPolicyText:'',
	}

    render() {

		const curDataStr = JSON.stringify(this.props.data)

		if(curDataStr !== this.lastDataStr) {
			const {
				countries,
				color,
				severityGradient,
				
				//TODO: remove:
				// eventsType,

				eventsTypes,
				dailyDataType,
				showPerCapita,
				xAxisAsDaysSincePatientZero,
				showDelta,
				yAxesType,
				coronaData
			} = this.props.data	
			this.lastDataStr = 	curDataStr	
			// const graphData = Object.assign( {}, this.basicData );
			const graphData = {
				labels: [],
				datasets: [],
				hebrewLegend: coronaData.hebrew_legend,
				eventsType: "",
				severityGradient: severityGradient,
			}

			if( this.yAxesType !== yAxesType ) {
				this.userOptions = Object.assign( {}, this.basicOptions );
				this.userOptions.scales.yAxes.forEach( a => a.type = yAxesType );
				this.yAxesType = yAxesType;

				this.redraw = true;
			} else { 
				this.redraw = false; 
			}

			if( this.xAxisAsDaysSincePatientZero !== xAxisAsDaysSincePatientZero ) {

				this.userOptions.scales.xAxes[0].ticks.callback = 
					function(value, index, values) {
						
						return xAxisAsDaysSincePatientZero ? index : value;
					}
				this.xAxisAsDaysSincePatientZero = xAxisAsDaysSincePatientZero;
				this.redraw = true;
			}

			if( this.showDelta !== showDelta ) {

				this.userOptions.scales.yAxes[0].ticks.callback = 
					function( value, index, values ) {
						let displayValue = value;
						if( showDelta ) {
							displayValue += "%"
						}
						return displayValue;
					}

				this.showDelta = showDelta;
				this.redraw = true;

			} 

			countries.forEach((country, i) => {

				if( !country.isActive ) { return; }

				const countryData = coronaData.data[ country.name ];
				const countryDailyData = countryData[dailyDataType];

				const dataSet = Object.assign( {}, this.basicDataSet );
				dataSet.label = country.name;
				
				if( countryDailyData === undefined ) { 
					
					console.log( country.name + " does not have " + dailyDataType );
					graphData.datasets.push(dataSet);
					return; 
				}

				const patientZeroDate = new Date( countryData.constant.paitent_zero_date );



				const lineColor = color[i];
				dataSet.borderColor = lineColor;
				// dataSet.backgroundColor = lineColor + "66";
				// dataSet.pointBorderColor = lineColor;
				// dataSet.pointHoverBackgroundColor = lineColor;

				const covidPointsData = {
					pointsRadiuses: [],
					pointColors: [],
					pointHoverRadius: [],
					pointsLabels: [],
					pointSeverities: [],
					dailyPolicyEventsData: [],
					
				};
				const graphNumbers = [];

				for( let i=0; i<countryDailyData.length; i++ ) {
				
					const currData = countryDailyData[ i ];
					
					if(currData === undefined) return;
					
					const date = new Date( currData.d );

					let value = 0;
					
					if( showDelta ) {
						if( showPerCapita ) {
							value = getLastSevenDaysAvgChange( countryDailyData, "dmpc", i );
						} else {

							value = getLastSevenDaysAvgChange( countryDailyData, "dv", i );
							
						}
					} else {
						if( showPerCapita ) {
							value = currData.mpc;
						} else {
							value = currData.v;
						}
					}
					
					if( xAxisAsDaysSincePatientZero ) {
						
						const daysSincePatientZero = Math.max(0,Math.floor((date.getTime() - patientZeroDate.getTime()) / (1000 * 3600 * 24)));
						const thisYear =  new Date().getFullYear();
						const beginingOfYear = new Date( thisYear, 0, 0 );
						const syncedDate =  addDays( beginingOfYear, daysSincePatientZero );
						
						graphNumbers.push( { t: syncedDate, y: value } );

					} else {

						graphNumbers.push( { t: date, y: value } );
					}

					

					// Find policy events that correspond to this dailyData dates:
					
					let eventText = "";
					let eventSeverity = 0;
					const allDailyEvents = []; // For future use, in cas we want to present more detailed events on hover or clicks.


					eventsTypes.forEach( ev => {
						if( !ev ) return;
						
						if( countryData[ ev ] === undefined ) { 
							
							// console.log( "no policy event data of type " + ev + " for " + country.name );

							covidPointsData.pointsRadiuses.push( 0 );
							covidPointsData.pointsLabels.push( "null" );
							covidPointsData.dailyPolicyEventsData.push( [] );
							covidPointsData.pointHoverRadius.push( 0 );
							covidPointsData.pointColors.push( lineColor );
							covidPointsData.pointSeverities.push( 0 );
							
							return; 
						}


						countryData[ ev ].forEach(element => {

							if( element.d === currData.d && element.text !== undefined ) {
								eventText += element.text + "</br>";

								// Make sure the most sever policy is the one that shows:
								if( element.v > eventSeverity ) {

									eventSeverity = element.v;
									graphData.eventsType = ev;
								}

								allDailyEvents.push( element );
							}
							
						});

					} )

					if( eventText !== "" ) {
						const color = global.getSeverityColor( eventSeverity );

						covidPointsData.pointsRadiuses.push( 3 + eventSeverity * 2 );
						covidPointsData.pointsLabels.push( eventText );
						covidPointsData.dailyPolicyEventsData.push( allDailyEvents );
						covidPointsData.pointHoverRadius.push( 7 );
						covidPointsData.pointColors.push( color.toRgbString() );
						covidPointsData.pointSeverities.push( eventSeverity );
					} else {
						covidPointsData.pointsRadiuses.push( 0 );
						covidPointsData.pointsLabels.push( "null" );
						covidPointsData.dailyPolicyEventsData.push( [] );
						covidPointsData.pointHoverRadius.push( 0 );
						covidPointsData.pointColors.push( lineColor );
						covidPointsData.pointSeverities.push( 0 );
					}

				}
				
				// dataSet.labels = labels;
				dataSet.data = graphNumbers;

				dataSet.pointRadius = covidPointsData.pointsRadiuses;
				dataSet.pointHoverRadius = covidPointsData.pointHoverRadius;
				dataSet.pointBackgroundColor = covidPointsData.pointColors;

				// add policy events to the graph data so it would be accessible through tooltips callbacks:
				dataSet.covidPointsData = covidPointsData;

				// console.log( covidPointsData );

				graphData.datasets.push(dataSet)
			})

			if( graphData.datasets.length > 0 ) {

				let min = new Date( "1/1/2020");

				if(  graphData.datasets.length === 1 ) {
					try{
						min = graphData.datasets[0].data[0].t;
					} catch (err) { console.warn( "can't set country min date. Details: " + err )}
				}

				this.userOptions.plugins.zoom.pan.rangeMin.x = min;
				this.userOptions.plugins.zoom.pan.rangeMax.x = Date.now();
	
				this.userOptions.plugins.zoom.zoom.rangeMin.x = min;
				this.userOptions.plugins.zoom.zoom.rangeMax.x = Date.now();

			}
			
			this.curGraphData = graphData
			
		}

		return <div className="lineChartCont">
                <Line key={"graph"} redraw={this.redraw} data={this.curGraphData} options={this.userOptions}/>
        </div>
        
    }
}

function addDays(date, days) {
    var result = new Date(date);
    result.setDate(date.getDate() + days);
    return result;
}

// function daysSinceBeginingOfYear() {
// 	const now = new Date();
// 	const start = new Date(now.getFullYear(), 0, 0);
// 	const diff = (now - start) + ((start.getTimezoneOffset() - now.getTimezoneOffset()) * 60 * 1000);
// 	const oneDay = 1000 * 60 * 60 * 24;
// 	const day = Math.floor(diff / oneDay);

// 	return day;
// }

function getLastSevenDaysAvgChange( data, type, index ) {

	let sum = 0;
	let count = 0;

	for( let i= Math.max(0,index - 7); i <= index; i++ ) {

		const value = 100 * data[i][type] / data[  Math.max( 0, i - 1 ) ].v;

		sum += value;
		count ++;
	}

	return sum / count;

}